<template>
  <div id="map-results">
    <div v-if="invalid_state_province">
      <error-component>
        <template slot="title">
          <h1>404 Error</h1>
        </template>
        <template slot="subtitle">
          <h2>Page not found</h2>
        </template>
        <template slot="message">
          <p>
            Missing a Partnership? Add a new Partnership by following the link below.
          </p>
        </template>
      </error-component>
    </div>
    <div v-if="!invalid_state_province && empty_state_province">
      <error-component>
        <template slot="title">
          <h1>{{ state_province }} Has No Partnerships</h1>
        </template>
        <template slot="subtitle">
          <h2>No partnerships found Try another state/province.</h2>
        </template>
        <template slot="message">
          <h4>Missing a Partnership? Add a Partnership by following the link below.</h4>
        </template>
      </error-component>
    </div>
    <div v-if="!invalid_state_province && !empty_state_province">
      <div class="loading-screen" v-if="loading">
        <b-row>
          <b-col md="12">
            <h2>Loading...</h2>
          </b-col>
        </b-row>
      </div>
      <div :class="loading ? 'hidden' : 'content'">
        <div id="map-wrapper">
          <maps
            :clickDisabled="true"
            :options="map_options">
              <template slot="title-rows">
                <b-row class="title-rows">
                  <b-col>
                    <h3 id="explore-title">Partnerships With {{ map_options.state_province }}</h3>
                  </b-col>
                </b-row>
              </template>
          </maps>
        </div>
        <div id="results">
          <b-row class="header-row">
            <b-col md="12">
              <h1>Partnerships</h1>
              <h2>{{ map_options.state_province }}</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <div id="map-results-filter">
                <b-row>
                  <b-col md="4">
                    <b-form-group
                      label="Order"
                      label-for="order">
                        <b-form-select
                          id="order"
                          :options="order_options"
                          v-model="order">
                        </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                      label="Sector"
                      label-for="sector">
                        <b-form-select
                          id="sector"
                          :options="sector_options"
                          text-field="name"
                          value-field="name"
                          v-model="sector">
                            <template slot="first">
                              <option value="">All Sectors</option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                      label="Type"
                      label-for="type">
                        <b-form-select
                          id="type"
                          :options="type_options"
                          text-field="name"
                          value-field="name"
                          v-model="type">
                            <template slot="first">
                              <option value="">All Types</option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <br>
              <div id="results-block" v-if="programs.length > 0">
                <div class="results-content" v-for="(program, index) in page_programs">
                  <b-row class="results-row" @click="goToPartnership(program.slug)">
                    <b-col md="12">
                      <h2 class="results">{{ program.name }}</h2>
                      <strong>Sector:</strong> {{ program.sector }}
                      <br>
                      <strong>Type:</strong> {{ program.type }}
                      <br>
                      <strong>States/Provinces:</strong>
                      <span v-for="(institution, index) in program.institutions">
                        {{ (index != (program.institutions.length - 1)) ? institution.state_province + ',' : institution.state_province }}
                      </span>
                      <br>
                      <strong>Institutions:</strong>
                      <span v-for="(institution, index) in program.institutions">
                        {{ (index != (program.institutions.length - 1)) ? institution.name + ',' : institution.name }}
                      </span>
                    </b-col>
                  </b-row>
                  <hr :class="(index !== (page_programs.length - 1)) ? 'separator' : 'separator-lg'">
                </div>
                <pagination
                  :click-handler="changePage"
                  :page="page"
                  :page-count="programs.length"
                  v-if="programs.length > 1">
                </pagination>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cleanQuery from 'clean-query'
import ErrorComponent from '@/components/ErrorComponent'
import Maps from '@/components/Maps'
import Pagination from '@/components/Pagination'

export default {
  name: 'MapResults',
  components: {
    ErrorComponent,
    Maps,
    Pagination
  },
  data: () => ({
    state_province: '',
    map_options: {},
    page: 1,
    programs: [],
    page_programs: [],
    num_programs: 0,
    order: undefined,
    type: undefined,
    sector: undefined,
    order_options: [
      { value: 'asc', text: 'A-Z' },
      { value: 'desc', text: 'Z-A' }
    ],
    sector_options: [],
    type_options: [],
    loading: true,
    empty_state_province: false,
    invalid_state_province: false
  }),
  methods: {
    changePage (page) {
      page = (this.programs[page - 1] !== undefined) ? page : 1
      this.page = page
      this.page_programs = this.programs[page - 1]

      let query = cleanQuery({
        order: this.order,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      })

      this.$router.replace({
        path: (query !== '') ? this.$route.path + '?' + query : this.$route.path
      })
    },
    handleError (error) {
      /* eslint-disable no-self-assign */
      error = error
      return null
    },
    getResults () {
      let query = cleanQuery({
        state_province: this.$route.params.state_province_slug,
        order: this.order,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      })

      this.axios({
        method: 'get',
        url: (query !== '') ? '/program/search?' + query : ''
      }).then(response => {
        this.map_options = {
          country: response.data.country,
          state_province: response.data.state_province,
          slug: response.data.state_province_slug,
          state_provinces: response.data.state_provinces
        }

        this.programs = response.data.programs
        this.num_programs = response.data.num_programs
        this.changePage(this.page)
        this.loading = false
      })
    },
    goToPartnership (slug) {
      this.$router.push({
        path: '/partnership/' + slug
      })
    },
    updateSelect () {
      let query = cleanQuery({
        order: this.order,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      })

      this.$router.replace({
        path: (query !== '') ? this.$route.path + '?' + query : this.$route.path
      })

      this.getResults()
    }
  },
  watch: {
    order () {
      this.updateSelect()
    },
    sector () {
      this.updateSelect()
    },
    type () {
      this.updateSelect()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.axios({
        method: 'get',
        url: '/program/search?state_province=' + to.params.state_province_slug
      }).then(response => {
        if (response.data.length === 0) {
          vm.invalid_state_province = true
        } else if (response.data.num_programs === 0) {
          vm.loading = false
          vm.empty_state_province = true
          vm.state_province = response.data.state_province
          vm.$root.setTitle(vm.state_province + ' | ' + 'Map Results')
        } else {
          vm.$root.setTitle('Map Results')
          vm.order = ((to.query.order !== undefined)) ? to.query.order : undefined
          vm.sector = ((to.query.sector !== undefined)) ? to.query.sector : undefined
          vm.type = ((to.query.type !== undefined)) ? to.query.type : undefined
          vm.page = ((to.query.page !== undefined)) ? Number(to.query.page) : undefined
          vm.getResults()
        }
      })

      vm.axios({
        method: 'get',
        url: 'sectors'
      }).then(response => {
        vm.sector_options = response.data.sort()
      })

      vm.axios({
        method: 'get',
        url: 'types'
      }).then(response => {
        vm.type_options = response.data.sort()
      })
    })
  }
}
</script>

<style lang="scss" scoped>
  .hidden {
    visibility: hidden;
  }

  .header-row {
    text-align: center;
  }

  .header-row h1 {
    text-transform: capitalize;
  }

  .header-row h2 {
    font-style: italic;
  }

  #results {
    padding-top: 2rem;
    padding-left: 2.5%;
    padding-right: 2.5%;
  }

  #results-block strong {
    font-family: 'urwgroteskregular', sans-serif;
    font-weight: normal
  }

  h2.results {
    font-family: 'urwgroteskregular', sans-serif;
    text-transform: capitalize;
  }

  h2.results:active,
  h2.results:focus,
  h2.results:hover {
    text-decoration: underline;
    color: rgb(215, 25, 32);
  }

  .separator-lg {
    margin-top: 5%;
    background-color: rgba(95, 95, 95, 0.95);
    width: 100%;
    position: relative;
  }

  .results-content {
    padding-left: 0.25%;
    padding-right: 0.25%;
  }

  .results-row {
    cursor: pointer;
    font-family: 'urwgroteskligregular', sans-serif;
  }

  .loading-screen {
    position: relative;
    background-color: #000000;
    color: #ffffff;
    text-align: center;
    padding-top: 10%;
    padding-bottom: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MapResults.vue